// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"488":"efe3797b","727":"0a23e27f","853":"c235f5ac","996":"7f87030e"}[chunkId] + ".chunk.css";
};